import store_fiche from "@/store/mods/consultations/fiche-consultations"
import $ from 'jquery'

export default {
    name: 'manage-fiche-champ',
    components: {},
    props: {
        selected_section: Object,
        liste_champs: Array,
        m_toggler: Number
    },
    data() {
        return {
            select_all: '',
            checked_champs: [],
            all_checked: false,
            one_is_checked: [],
            save_loading: false,
            is_error: false,
            err_message: "",

            all_champs: [],
            all_champ_empty: false,
            all_champ_loading: true
        }
    },


    watch: {
        m_toggler() {
            this.getAllChampByDataType()
        }
    },

    computed: {

    },

    mounted() {
        
    },

    methods: {
        toutSelectionner() {
            let is_checked = $('#ts-champs').is(":checked")

            if (is_checked) {
                this.one_is_checked = []

                this.all_champs.forEach((data) => {
                    if (this.selected_section.is_certif_type == 1 && data.type_champ == 'Editeur de texte') {
                        this.one_is_checked.push(data.champ_id) 
                    } else if (this.selected_section.is_certif_type == 0) {
                        this.one_is_checked.push(data.champ_id)
                    }
                    
                });
                this.all_checked = true
                
            } else {
                this.one_is_checked = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("ts-champs").checked = false;
        },

        getAllChampByDataType() {
            this.all_champ_loading = true
            const data_type = 'champ_fiche'
            store_fiche.geAllChampsByDataType(data_type).then((champs) => {
                this.all_champs = champs
                if (champs.length == 0) {
                    this.all_champ_empty = true
                } else {
                    this.all_champ_empty = false
                }

                this.all_champ_loading = false

                this.autoCheckBox()
            })
        },

        autoCheckBox() {
            if (this.liste_champs.length > 0) {
                this.liste_champs.forEach((defined_champ) => {
                    this.all_champs.forEach((c) => {
                        if (defined_champ.champ_id == c.champ_id) {
                            this.one_is_checked.push(c.champ_id)
                        }
                    });
                })
            }
        },

        save() {
            const data = {
                fcs_id: this.selected_section.fcs_id,
                champs: this.one_is_checked
            }
            
            this.save_loading = true
            store_fiche.updateChampListe(data).then((response) => {
                if (response.success) {
                    this.one_is_checked = []
                    this.$refs.u_champ.click()
                    this.successToast(response.message)

                    this.$emit('emitListChamp')
                } else {
                    this.err_message = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.$refs.u_champ.click()
                this.errorToast("Une erreur s'est produite !")
            })
        }
    }
}